import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import PermissionChecklist, { RoleBadge, useStaffMeta } from "@/components/app/PermissionChecklist";
import { toast } from "sonner";

export default function StaffRoles() {
  const meta = useStaffMeta();
  const { user } = useAuth();
  const [defaults, setDefaults] = useState([]);
  useEffect(() => { if (meta) setDefaults(meta.employee_defaults); }, [meta]);
  const canEdit = user?.staff_role !== "dipendente";
  const save = async () => {
    try { const { data } = await api.put("/staff-roles/defaults", { permissions: defaults }); setDefaults(data.employee_defaults); toast.success("Permessi predefiniti aggiornati"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  if (!meta) return <div className="text-slate-500">Caricamento…</div>;
  return (
    <div className="space-y-6 max-w-4xl" data-testid="staff-roles">
      <div>
        <h1 className="font-display text-3xl font-extrabold text-slate-900">Ruoli e Permessi</h1>
        <p className="text-slate-500 mt-1">I permessi del singolo dipendente si possono personalizzare dalla sua scheda senza cambiare ruolo.</p>
      </div>
      <Card className="border-slate-200"><CardContent className="p-6 space-y-3">
        <div className="flex items-center gap-2"><RoleBadge role="amministratore" /><span className="font-display font-bold">Amministratore</span></div>
        <div className="text-sm text-slate-600">Accesso completo a tutte le funzionalità del gestionale, gestione di dipendenti e permessi, configurazioni di sistema.</div>
        <PermissionChecklist meta={meta} value={meta.permissions.map((p) => p.key)} onChange={() => {}} disabled testPrefix="role-admin-perm" />
      </CardContent></Card>
      <Card className="border-slate-200"><CardContent className="p-6 space-y-3">
        <div className="flex items-center gap-2"><RoleBadge role="dipendente" /><span className="font-display font-bold">Dipendente · permessi predefiniti</span></div>
        <div className="text-sm text-slate-600">Proposti automaticamente quando crei un nuovo dipendente.</div>
        <PermissionChecklist meta={meta} value={defaults} onChange={setDefaults} disabled={!canEdit} testPrefix="role-default-perm" />
        {canEdit && <div className="flex justify-end"><Button onClick={save} className="bg-[#0F2942] hover:bg-[#1B3B5F]" data-testid="role-defaults-save">Salva permessi predefiniti</Button></div>}
      </CardContent></Card>
    </div>
  );
}
